import { render } from "./StockWithdrawalList.vue?vue&type=template&id=2a018ab8"
import script from "./StockWithdrawalList.vue?vue&type=script&lang=js"
export * from "./StockWithdrawalList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__